import { fmtD } from "@/lib/pipelineApi";
import { fmtMT } from "@/lib/mountainTime";
import { OUTCOMES, money } from "./SaleRecordForm";
import { REASONS } from "./WithdrawFields";

const OUT = Object.fromEntries(OUTCOMES), WHY = Object.fromEntries(REASONS);
const SRC = { contract: "signed contract", smartsheet: "Smartsheet", admin: "entered by admin", calculated: "calculated" };

const R = ({ k, v, t }) => (
  <div className="flex justify-between gap-3 text-sm py-0.5"><span className="text-stone-500">{k}</span><span data-testid={t} className="font-semibold text-stone-900 text-right">{v ?? "—"}</span></div>
);

export function SaleOutcomePanel({ r }) {
  const w = r.withdrawal;
  const pct = r.commission_percent != null ? `${r.commission_percent}%${r.commission_percent_source ? ` (${SRC[r.commission_percent_source]})` : ""}` : "Unknown";
  return (
    <section data-testid="pipeline-sale-record" className="rounded-xl border border-stone-200 bg-white p-4">
      <h3 className="text-xs font-bold uppercase tracking-wider text-stone-500 mb-2">Sale Outcome <span className="normal-case font-normal">· private</span></h3>
      <R k="Outcome" v={OUT[r.outcome] || "Not recorded"} t="sale-record-outcome" />
      {r.outcome === "withdrawn" ? <>
        <R k="Reason" v={WHY[w?.reason] || "None given"} t="sale-record-withdraw-reason" />
        {w?.explanation && <p data-testid="sale-record-withdraw-explanation" className="text-sm text-stone-700 py-0.5">{w.explanation}</p>}
        <R k="Withdrawn" v={w && `${fmtMT(w.at)} · ${w.by}`} t="sale-record-withdrawn-by" />
        <R k="Website" v={w?.hidden_from_website ? "Hidden" : "Not hidden"} t="sale-record-withdraw-website" />
      </> : <>
        <R k="Final auction bid" v={money(r.final_bid)} t="sale-record-final-bid" />
        <R k="Actual sale price" v={money(r.sale_price)} t="sale-record-sale-price" />
        <R k="Difference" v={r.bid_difference != null ? money(r.bid_difference) : "—"} t="sale-record-difference" />
        <R k="Commission %" v={pct} t="sale-record-commission-percent" />
        <R k="Commission amount" v={r.commission_amount != null ? `${money(r.commission_amount)}${r.commission_amount_source ? ` (${SRC[r.commission_amount_source]})` : ""}` : "—"} t="sale-record-commission-amount" />
        {r.commission_calculated != null && r.commission_amount != null && Math.abs(r.commission_calculated - r.commission_amount) > 0.005 && <R k="Calculated commission" v={money(r.commission_calculated)} t="sale-record-commission-calculated" />}
        <R k="Buyer" v={r.buyer?.name} t="sale-record-buyer" />
        <R k="Sale date" v={fmtD(r.sold_at)} t="sale-record-date" />
      </>}
      {r.smartsheet && <p data-testid="sale-record-smartsheet" className="text-[11px] text-stone-500 mt-2">Smartsheet original: bid {money(r.smartsheet.final_bid)}, sold {money(r.smartsheet.sale_price)}, {r.smartsheet.commission_percent ?? "—"}% = {money(r.smartsheet.commission_amount)}</p>}
    </section>
  );
}
